import ItemsViewMainContent from "@features/report/components/Items/ItemsViewMainContent";
import { useDevice } from "@hooks/useDevice";
import type { BaseItemSchema } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import EmptyState from "@memorang/ui/components/EmptyView";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { QuickActionChips } from "components/QuickActionChips";
import { router } from "expo-router";
import { Card } from "react-native-paper";
import { usePrinting } from "../../hooks/usePrinting";
import PrintButton from "../print/PrintButton";
import PrintableReportContainer from "../print/PrintableReportContainer";
import { EMPTY_STATE_CONFIG, formatFilterSummary } from "./constants";
import type { ItemFilterType } from "./types";
import useItemsFilter from "./useItemsFilter";

type Props = {
	sessionItems?: BaseItemSchema[];
	isDetailView?: boolean;
};
const ItemsDetailView = ({ sessionItems, isDetailView }: Props) => {
	const {
		filters,
		handleSelectFilter,
		handleClearFilters,
		localItems,
		breadcrumbs,
		selectedFilters,
	} = useItemsFilter(sessionItems);
	const { isMobile } = useDevice();
	const { isPrintMode } = usePrinting();

	const showEmptyState = !localItems?.length;

	const activeFilters = selectedFilters.filter((f) => f !== "all");
	const filterSummary = formatFilterSummary(activeFilters);

	if (isPrintMode) {
		return <PrintableReportContainer />;
	}

	return (
		<>
			<CustomAppBar
				title="Item performance"
				leftIconType="back"
				onPressBack={() => router.back()}
				breadcrumbs={breadcrumbs}
				renderRight={() => <PrintButton />}
				hideCommandBar
			/>
			<Box flex={1}>
				<ScrollContainer maxWidth="sm">
					<Box paddingTop={isMobile ? 16 : 24}>
						<QuickActionChips
							quickActionsChips={filters}
							handleQuickActionPress={(filter) => {
								handleSelectFilter(filter as ItemFilterType);
							}}
						/>
					</Box>
					{showEmptyState ? (
						<Box
							justifyContent="center"
							alignItems="center"
							height={isMobile ? "90%" : "100%"}
						>
							<EmptyState
								icon={EMPTY_STATE_CONFIG.icon}
								title={EMPTY_STATE_CONFIG.title}
								subtitle={EMPTY_STATE_CONFIG.getDescription(filterSummary)}
								cta={EMPTY_STATE_CONFIG.ctaLabel}
								handleAction={handleClearFilters}
							/>
						</Box>
					) : (
						<>
							{isMobile ? (
								<ItemsViewMainContent
									numTotalItems={localItems.length}
									localItems={localItems}
								/>
							) : (
								<Box flex={1} paddingVertical={24}>
									<Card
										style={{
											flex: 1,
										}}
									>
										<ItemsViewMainContent
											numTotalItems={localItems.length}
											localItems={localItems}
											isDetailView={isDetailView}
										/>
									</Card>
								</Box>
							)}
						</>
					)}
				</ScrollContainer>
			</Box>
		</>
	);
};

export default ItemsDetailView;
